export const FETCH_SOURCE = 'FETCH_SOURCE'
export const FETCH_FILTER_GROUPS = 'FETCH_FILTER_GROUPS'

export const UPDATE_SOURCE = 'UPDATE_SOURCE'
export const UPDATE_SOURCE_FIELD = `${UPDATE_SOURCE}_UPDATE_FIELD`
export const UPDATE_SOURCE_SUBMIT = `${UPDATE_SOURCE}_SUBMIT_FULL_UPDATE`

export const SELECT_SOURCE = 'SELECT_SOURCE'
export const RESET_SOURCE = 'RESET_SOURCE'

export const SERVER_RESOURCE = '/subscriptions'



// WEBPACK FOOTER //
// ./src/pages/source-config/constants.ts